import { render, staticRenderFns } from "./ViewDeliverysetup.vue?vue&type=template&id=455178c2&scoped=true"
import script from "./ViewDeliverysetup.vue?vue&type=script&lang=js"
export * from "./ViewDeliverysetup.vue?vue&type=script&lang=js"
import style0 from "./ViewDeliverysetup.vue?vue&type=style&index=0&id=455178c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455178c2",
  null
  
)

export default component.exports